import { Mail, Phone, MapPin } from "lucide-react";
import { ACCENT } from "../constants/theme";

export default function Footer({ setPage }) {
  const links = ["Home", "About", "Training Programs", "Join Us", "Contact", "Credits"];
  const logo = "/nexus.png";

  return (
    <footer
      aria-label="Site Footer"
      style={{
        background: "#f8fafc",
        borderTop: "1px solid #e2e8f0",
        padding: "56px 24px 32px",
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: 40,
            marginBottom: 48,
          }}
        >
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
              <img
                src={logo}
                alt="Nexus Studio Logo"
                style={{ width: 36, height: 36, objectFit: "contain" }}
              />

              <span style={{ fontWeight: 800, fontSize: 20, color: "#0f172a" }}>
                Nexus<span style={{ color: ACCENT }}>Studio</span>
              </span>
            </div>

            <p style={{ color: "#64748b", fontSize: 14, lineHeight: 1.7, maxWidth: 260 }}>
              Vision Beyond Inclusion. A creative platform where every voice belongs.
            </p>
          </div>

          <nav aria-label="Footer Quick Links">
            <h2
              style={{
                fontWeight: 700,
                fontSize: 14,
                color: "#0f172a",
                marginBottom: 16,
                textTransform: "uppercase",
                letterSpacing: "0.06em",
              }}
            >
              Quick Links
            </h2>

            {links.map((l) => (
              <button
                type="button"
                key={l}
                onClick={() => setPage(l)}
                style={{
                  display: "block",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "#64748b",
                  fontSize: 14,
                  padding: "5px 0",
                  textAlign: "left",
                }}
                onMouseOver={(e) => (e.currentTarget.style.color = ACCENT)}
                onMouseOut={(e) => (e.currentTarget.style.color = "#64748b")}
              >
                {l}
              </button>
            ))}
          </nav>

          <address style={{ fontStyle: "normal" }}>
            <h2
              style={{
                fontWeight: 700,
                fontSize: 14,
                color: "#0f172a",
                marginBottom: 16,
                textTransform: "uppercase",
                letterSpacing: "0.06em",
              }}
            >
              Contact
            </h2>

            <p style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10, color: "#64748b", fontSize: 14 }}>
              <span style={{ color: ACCENT }} aria-hidden="true"><Mail size={14} /></span>
              <a href="mailto:hello@nexusstudio.in" style={{ color: "inherit", textDecoration: "none" }}>
                hello@nexusstudio.in
              </a>
            </p>

            <p style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10, color: "#64748b", fontSize: 14 }}>
              <span style={{ color: ACCENT }} aria-hidden="true"><Phone size={14} /></span>
              <a href="tel:+918320557290" style={{ color: "inherit", textDecoration: "none" }}>
                +91 83205 57290
              </a>
            </p>

            <p style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10, color: "#64748b", fontSize: 14 }}>
              <span style={{ color: ACCENT }} aria-hidden="true"><MapPin size={14} /></span>
              Ahmedabad, Gujarat, India
            </p>
          </address>
        </div>

        <div
          style={{
            borderTop: "1px solid #e2e8f0",
            paddingTop: 24,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <p style={{ color: "#94a3b8", fontSize: 13 }}>
            © 2026 Nexus Studio. All rights reserved.
          </p>
          <p style={{ color: "#94a3b8", fontSize: 13 }}>Vision Beyond Inclusion.</p>
        </div>
      </div>
    </footer>
  );
}